import React from 'react';

// components
import { useIsMobile } from 'paper/hooks/isMobile';
import Form from '../Form';

// helpers

interface ErrorProps {
  closeModal: (shouldNotDisableMulti?: boolean) => void;
  singleSampleAvailable: boolean;
}

const FlowError = ({ closeModal, singleSampleAvailable }: ErrorProps): JSX.Element => {
  const isMobile = useIsMobile();

  const itemInCart =
    'Your cart contains items and they need to be removed or checked out before you can start customizing your free sample!';
  const limit =
    'If you liked our printing quality and want to proof a customized card, you can order a quantity of 1 instead.';

  const nextBtnText = 'Go To Checkout';
  const nextStep = () => (window.location.href = '/cart/checkout');
  const prevBtnText = 'Continue Shopping';
  const prevStep = () => closeModal();

  return (
    <>
      <Form.Header
        description={singleSampleAvailable ? itemInCart : limit}
        title={
          singleSampleAvailable
            ? 'Ooops! Please check your cart'
            : "Whoa there! You've hit the maximum"
        }
      />
      <Form.ButtonWrapper>
        {singleSampleAvailable ? (
          <>
            <Form.Button
              btnText={isMobile ? nextBtnText : prevBtnText}
              handleClick={isMobile ? nextStep : prevStep}
              variant={isMobile ? 'primary' : 'secondary'}
            />
            <Form.Button
              btnText={isMobile ? prevBtnText : nextBtnText}
              handleClick={isMobile ? prevStep : nextStep}
              variant={isMobile ? 'secondary' : 'primary'}
            />
          </>
        ) : (
          <Form.Button btnText="Got It" handleClick={() => closeModal()} />
        )}
      </Form.ButtonWrapper>
    </>
  );
};

export default FlowError;
